module.exports = __webpack_public_path__ + "static/media/hatchef.9f184c69.svg";